/**
 * This file is necessary because webpack expects to be able to resolve module names
 * at build-time. There is some documentation on dynamic remote containers, but
 * I wasn't able to figure out how that works at this time. Perhaps future enhancement:
 * https://webpack.js.org/concepts/module-federation/#dynamic-remote-containers
 */

import type { PluginPackageExports } from '@/types';

interface RemoteModuleImportMap {
    [key: string]: () => Promise<PluginPackageExports>;
}

// We need to ts-ignore the types on these modules and assume they follow the
// PluginPackageExports contract, because we can't cross reference types across modules
// at build-time. Member application types are built first, before all the remote modules.
const remoteModuleImportMap: RemoteModuleImportMap = {
    'commercial-web-client-member-plan-comparison-tool': () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return import('commercial-web-client-member-plan-comparison-tool/dist/exports');
    },
    'commercial-web-client-employer-login': () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return import('commercial-web-client-employer-login/dist/exports');
    },
};

export default remoteModuleImportMap;

